/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  BaseManuscriptSearchResult,
  ErrorInfo,
  BaseManuscriptSearchConditions,
  BaseManuscriptFlistSearchResult,
  BinaryFile,
  BaseManuscriptFListDownload,
  PostBaseManuscriptsImportBody,
  BaseManuscriptDownload,
  PostBaseManuscriptCreateOri200,
  CreateOriErrorDownload
} from '.././model'


/**
 * ベース原稿一覧を検索して返す。

 * @summary ベース原稿一覧検索
 */
export const postBaseManuscriptsSearch = (
    baseManuscriptSearchConditions: BaseManuscriptSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BaseManuscriptSearchResult>> => {
    return axios.post(
      `/baseManuscripts/search`,
      baseManuscriptSearchConditions,options
    );
  }



    export type PostBaseManuscriptsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsSearch>>>
    export type PostBaseManuscriptsSearchMutationBody = BaseManuscriptSearchConditions
    export type PostBaseManuscriptsSearchMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsSearch>>, TError,{data: BaseManuscriptSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsSearch>>, {data: BaseManuscriptSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postBaseManuscriptsSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsSearch>>, TError, {data: BaseManuscriptSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース原稿F-List一覧一覧を検索して返す。

 * @summary ベース原稿F-List一覧検索
 */
export const postBaseManuscriptsFlistSearch = (
    baseManuscriptSearchConditions: BaseManuscriptSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BaseManuscriptFlistSearchResult>> => {
    return axios.post(
      `/baseManuscripts/flist/search`,
      baseManuscriptSearchConditions,options
    );
  }



    export type PostBaseManuscriptsFlistSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsFlistSearch>>>
    export type PostBaseManuscriptsFlistSearchMutationBody = BaseManuscriptSearchConditions
    export type PostBaseManuscriptsFlistSearchMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsFlistSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsFlistSearch>>, TError,{data: BaseManuscriptSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsFlistSearch>>, {data: BaseManuscriptSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postBaseManuscriptsFlistSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsFlistSearch>>, TError, {data: BaseManuscriptSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース原稿一覧を検索して、結果をExcel形式でダウンロードする。

 * @summary ベース原稿一覧検索結果ダウンロード
 */
export const postBaseManuscriptsFlistDownload = (
    baseManuscriptFListDownload: BaseManuscriptFListDownload, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/baseManuscripts/flist/download`,
      baseManuscriptFListDownload,options
    );
  }



    export type PostBaseManuscriptsFlistDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsFlistDownload>>>
    export type PostBaseManuscriptsFlistDownloadMutationBody = BaseManuscriptFListDownload
    export type PostBaseManuscriptsFlistDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsFlistDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsFlistDownload>>, TError,{data: BaseManuscriptFListDownload}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsFlistDownload>>, {data: BaseManuscriptFListDownload}> = (props) => {
          const {data} = props ?? {};

          return  postBaseManuscriptsFlistDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsFlistDownload>>, TError, {data: BaseManuscriptFListDownload}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース原稿一覧をインポート

 * @summary ベース原稿一覧インポート
 */
export const postBaseManuscriptsImport = (
    productionId: number,
    postBaseManuscriptsImportBody: PostBaseManuscriptsImportBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {const formData = new FormData();
if(postBaseManuscriptsImportBody.file !== undefined) {
 formData.append('file', postBaseManuscriptsImportBody.file)
 }

    return axios.post(
      `/baseManuscripts/${productionId}/import`,
      formData,options
    );
  }



    export type PostBaseManuscriptsImportMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsImport>>>
    export type PostBaseManuscriptsImportMutationBody = PostBaseManuscriptsImportBody
    export type PostBaseManuscriptsImportMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsImport = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsImport>>, TError,{productionId: number;data: PostBaseManuscriptsImportBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsImport>>, {productionId: number;data: PostBaseManuscriptsImportBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postBaseManuscriptsImport(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsImport>>, TError, {productionId: number;data: PostBaseManuscriptsImportBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース原稿一覧を検索して、結果をExcel形式でダウンロードする。

 * @summary ベース原稿一覧検索結果ダウンロード
 */
export const postBaseManuscriptsSearchDownload = (
    baseManuscriptDownload: BaseManuscriptDownload, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/baseManuscripts/search/download`,
      baseManuscriptDownload,options
    );
  }



    export type PostBaseManuscriptsSearchDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsSearchDownload>>>
    export type PostBaseManuscriptsSearchDownloadMutationBody = BaseManuscriptDownload
    export type PostBaseManuscriptsSearchDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsSearchDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsSearchDownload>>, TError,{data: BaseManuscriptDownload}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsSearchDownload>>, {data: BaseManuscriptDownload}> = (props) => {
          const {data} = props ?? {};

          return  postBaseManuscriptsSearchDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsSearchDownload>>, TError, {data: BaseManuscriptDownload}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORI原稿を作成する。

 * @summary ORI原稿作成
 */
export const postBaseManuscriptCreateOri = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostBaseManuscriptCreateOri200>> => {
    return axios.post(
      `/baseManuscripts/createORI/${productionId}`,undefined,options
    );
  }



    export type PostBaseManuscriptCreateOriMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptCreateOri>>>
    
    export type PostBaseManuscriptCreateOriMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptCreateOri = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptCreateOri>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptCreateOri>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postBaseManuscriptCreateOri(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptCreateOri>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース原稿ORIデータ作成でエラーが帰ってきたら、ログをダウンロードする。

 * @summary ベース原稿ORIデータ作成エラーログダウンロード
 */
export const postBaseManuscriptsCreateoriLogdownload = (
    createOriErrorDownload: CreateOriErrorDownload, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/baseManuscripts/createORI/logdownload`,
      createOriErrorDownload,options
    );
  }



    export type PostBaseManuscriptsCreateoriLogdownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postBaseManuscriptsCreateoriLogdownload>>>
    export type PostBaseManuscriptsCreateoriLogdownloadMutationBody = CreateOriErrorDownload
    export type PostBaseManuscriptsCreateoriLogdownloadMutationError = AxiosError<ErrorInfo>

    export const usePostBaseManuscriptsCreateoriLogdownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBaseManuscriptsCreateoriLogdownload>>, TError,{data: CreateOriErrorDownload}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBaseManuscriptsCreateoriLogdownload>>, {data: CreateOriErrorDownload}> = (props) => {
          const {data} = props ?? {};

          return  postBaseManuscriptsCreateoriLogdownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postBaseManuscriptsCreateoriLogdownload>>, TError, {data: CreateOriErrorDownload}, TContext>(mutationFn, mutationOptions)
    }
    